var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./integrationsAssignmentModal.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-342454e5!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./integrationsAssignmentModal.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app/components/modals/integrationsAssignmentModal.vue
// module id = 476
// module chunks = 61